import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TemplateStageType } from '@pt/models';

@Component({
  selector: 'pt-template-stage-image',
  templateUrl: './template-stage-image.component.html',
  styleUrl: './template-stage-image.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
})
export class TemplateStageImageComponent {
  templateStageType = input<TemplateStageType>('corporate');

  readonly #stageFillColors: Record<TemplateStageType, string[]> = {
    corporate:
      ['var(--corporate-color-1)', 'var(--corporate-color-2)', 'var(--corporate-color-3)'],
    professional: ['#0471d7', '#2c99ff', '#0471d7'],
    mentoring: ['#8500d7', '#ad00ff', '#9900eb'],
    swapAndWork: ['#d70034', '#ff005c', '#8701d9'],
    internship: ['#002e91', '#0056b9', '#00cfa6'],
  };

  get type(): string {
    return this.templateStageType() || 'corporate';
  }

  get filledColors(): string[] {
    return this.#stageFillColors[this.templateStageType()] || this.#stageFillColors['corporate'];
  }
}
